import { render } from "./LogosRequests.vue?vue&type=template&id=34c729cd"
import script from "./LogosRequests.vue?vue&type=script&lang=js"
export * from "./LogosRequests.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__